import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useQuery } from 'react-query';
import { POST, GET, getRecaptchaToken } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';

export const grantType = {
  OTP: 1,
  AuthCode: 2
}


export const Auth = ({ journeyGuid: journeyGUID, processGuid: processGUID, lngCode, rcaEnabled, clientStateData, useMock }) => {
  const baseApi = `${lngCode}/auth`;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const clientStateDataUpdate = useClientStateDataUpdate();

  return {
    //Get OTP token for OTP page
    async passwordless(generatedAuthParams, hasRecaptcha) {
      if (useMock) {
        return new Promise((resolve) =>
          resolve({ token: 'mockedToken', recipientAddress: '' })
        )
      }

      //
      const headers = !!rcaEnabled && hasRecaptcha && { headers: getRecaptchaToken(await executeRecaptcha('otp')) };
      return POST(`${baseApi}/passwordless`, { identity: journeyGUID, lngCode, clientStateData, ...generatedAuthParams }, headers)
    },
    //Auth token for the full access to the app
    async token(params, hasRecaptcha) {
      const headers = !!rcaEnabled && hasRecaptcha && { headers: getRecaptchaToken(await executeRecaptcha('auth')) };
      if (useMock) {
        var expiresIn = new Date();
        expiresIn.setDate(expiresIn.getDate() + 1);

        return new Promise((resolve) =>
          resolve({ accessToken: 'mockedToken', expiresIn })
        )

      }
      return POST(`${baseApi}/token`, {
        identity: journeyGUID, lngCode, clientStateData, ...params,
      }, headers)
        .then(res => {
          const { accessToken, tokenType, expiresIn } = res;
          if (res.clientStateData) { clientStateDataUpdate(res.clientStateData) }
          return { accessToken: `${tokenType} ${accessToken}`, expiresIn }
        })
    },

    useOtpConfigQuery(hasOtpVerification) {
      return useQuery(
        ['otp-config', journeyGUID],
        () => getOtpConfig(),
        { enabled: hasOtpVerification, staleTime: 60 * 1000 }
      );
    },
    useGetToken(isAuthenticated, onSuccess) {
      return useQuery(
        ['token-auth', journeyGUID, lngCode],
        () => getToken(),
        { enabled: isAuthenticated, onSuccess: onSuccess }
      );
    },

  };
  async function getToken() {
    const headers = !!rcaEnabled && { headers: getRecaptchaToken(await executeRecaptcha('auth')) };
    if (useMock)
      return Promise.resolve(() => {
        var expiresIn = new Date();
        expiresIn.setDate(expiresIn.getDate() + 1);
        return { accessToken: 'mockedToken', expiresIn }
      })

    return POST(`${baseApi}/token`, {
      identity: journeyGUID, lngCode, clientStateData,
    }, headers)
      .then(res => {
        if (res.clientStateData) { clientStateDataUpdate(res.clientStateData) }
        const { accessToken, tokenType, expiresIn } = res;
        return { accessToken: `${tokenType} ${accessToken}`, expiresIn }
      })
  }

  function getOtpConfig() { return GET(`${baseApi}/config`); }
}
